import { render, staticRenderFns } from "./MenteeDetailsModal.vue?vue&type=template&id=7a07f900&scoped=true&"
import script from "./MenteeDetailsModal.vue?vue&type=script&lang=js&"
export * from "./MenteeDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a07f900",
  null
  
)

export default component.exports